import React, { useState } from "react";
import { Layout, Menu, Button, Drawer, Row, Col, Badge, Dropdown } from "antd";
import {
  MenuOutlined,
  SearchOutlined,
  MailOutlined,
  UserOutlined,
  DownOutlined,
} from "@ant-design/icons";
import useIsSmallScreen from "../../hooks/useIsSmallScreen";
import { Outlet } from "react-router-dom";

const { Header } = Layout;

export default function PersonnelLayout() {
  const [drawerVisible, setDrawerVisible] = useState(false);
  const isMobile = useIsSmallScreen(1300);

  const toggleDrawer = () => {
    setDrawerVisible(!drawerVisible);
  };

  const menuItems = [
    { key: "isAra", label: "İş Ara" },
    { key: "islerim", label: "İşlerim" },
    { key: "kariyerPlanlamasi", label: "Kariyer Planlaması" },
    { key: "kariyerRehberi", label: "Kariyer Rehberi" },
  ];

  const profileMenuItems = [
    { key: "profile", label: "Profilim" },
    { key: "settings", label: "Ayarlar" },
    { key: "help", label: "Yardım" },
    { key: "logout", label: "Çıkış Yap" },
  ];

  const Logo = () => (
    <div style={{ display: "flex", alignItems: "center" }}>
      <span style={{ color: "#6f42c1", fontSize: "24px", fontWeight: "bold" }}>
        Hemen Personel
      </span>
    </div>
  );

  const DesktopMenu = () => (
    <Menu mode="horizontal" items={menuItems} style={{ border: "none" }} />
  );

  const MobileMenu = () => (
    <Drawer
      title={<Logo />}
      placement="left"
      onClose={toggleDrawer}
      open={drawerVisible}
      width={300}>
      <div style={{ padding: "20px 0" }}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            marginBottom: "20px",
          }}>
          <Badge count={1} size="small">
            <Button shape="circle" icon={<UserOutlined />} size="large" />
          </Badge>
          <div style={{ marginLeft: "10px" }}>
            <div style={{ fontWeight: "bold" }}>Mahmut Alpayci</div>
            <div style={{ color: "#6f42c1" }}>Hesabıma Git</div>
          </div>
        </div>
        <Menu mode="vertical" items={menuItems} style={{ border: "none" }} />
        <Menu
          mode="vertical"
          items={profileMenuItems}
          style={{ border: "none", marginTop: "20px" }}
        />
      </div>
    </Drawer>
  );

  return (
    <Layout>
      <Header
        style={{
          background: "#fff",
          padding: 0,
          boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
        }}>
        <div
          style={{
            margin: "0 auto",
            padding: isMobile ? "0 16px" : "0 32px",
            maxWidth: "1600px",
          }}>
          <Row
            align="middle"
            justify="space-between"
            style={{ height: "100%" }}>
            <Col>
              {isMobile && (
                <Button
                  icon={<MenuOutlined />}
                  onClick={toggleDrawer}
                  style={{ border: "none", marginRight: "16px" }}
                />
              )}
              <Logo />
            </Col>
            {!isMobile && (
              <Col flex={1}>
                <DesktopMenu />
              </Col>
            )}
            <Col>
              {isMobile ? (
                <div style={{ display: "flex", alignItems: "center" }}>
                  <Button
                    icon={<SearchOutlined />}
                    style={{ border: "none" }}
                  />
                  <Badge count={1} size="small">
                    <Button
                      icon={<MailOutlined />}
                      style={{ border: "none" }}
                    />
                  </Badge>
                </div>
              ) : (
                <Dropdown
                  menu={{ items: profileMenuItems }}
                  trigger={["click"]}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      cursor: "pointer",
                    }}>
                    {/* <Badge count={1} size="small">
                      <Button shape="circle" icon={<UserOutlined />} />
                    </Badge> */}
                    <span
                      style={{
                        marginLeft: "8px",
                        marginRight: "4px",
                        fontSize: 16,
                      }}>
                      Mahmut
                    </span>
                    <DownOutlined style={{ fontSize: "12px" }} />
                  </div>
                </Dropdown>
              )}
            </Col>
          </Row>
        </div>
      </Header>
      <MobileMenu />
      <Outlet></Outlet>
    </Layout>
  );
}
